import React from "react";
import Divider from "../Divider/Divider";
import { ClipboardText } from "iconsax-react";
import OutlinedButton from "../OutlinedButton/OutlinedButton";

type PayrollProcessToastProps = {
  text: string;
  percentage: number;
  payrollGroupName: string;
  remaining?: number;
};

const handlePayrollProcessStop = () => {
  sessionStorage.removeItem("payrollProcess");
  let interruptElement = document.getElementById("interrupt");
  interruptElement!.innerHTML = '<span class="font-thin text-md italic text-gray_03">Interrompendo processamento... Aguarde um momento</span>';
};

const PayrollProcessToast: React.FC<PayrollProcessToastProps> = ({ text, percentage, remaining, payrollGroupName }) => {
  return (
    <div className="px-5 w-full">
      <p className="my-2 font-bold text-black text-lg">Status do Processamento</p>
      <p className="my-2 font-bold text-sm text-black">Lote: <span className="font-thin italic tetx-gray_2">{payrollGroupName}</span></p>
      <Divider className="my-4 border-gray_05" />
      <div className="flex">
          <p className="font-thin text-md mr-2">{text}</p>
          <ClipboardText  size="20" color="#7B809A" />
      </div>
      <div className="flex w-full h-4 overflow-hidden font-sans text-xs font-medium rounded-full flex-start my-4">
          <div className="flex-start flex h-8.5 w-full overflow-hidden rounded-full bg-gray_0 text-xs font-bold">
              <div
                  className="flex items-center justify-center h-full overflow-hidden text-white text-bold break-all bg-green rounded-full p-1"
                  style={{ width: `${Math.max(20, percentage)}%` }}
              > {percentage.toFixed(0)}% </div>
          </div>
      </div>
      <div id="interrupt" className="flex py-2 bg-white">
        <div className="flex-1"></div>
        <div className="flex-1">
          <OutlinedButton
            className="w-full"
            type="button"
            onClick={handlePayrollProcessStop}
          > Interromper
          </OutlinedButton>
        </div>
      </div>
    </div>
  );
};

export default PayrollProcessToast;